import { render, staticRenderFns } from "./assetUse.vue?vue&type=template&id=2d86d94c&scoped=true"
import script from "./assetUse.vue?vue&type=script&lang=js"
export * from "./assetUse.vue?vue&type=script&lang=js"
import style0 from "./assetUse.vue?vue&type=style&index=0&id=2d86d94c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d86d94c",
  null
  
)

export default component.exports